<template>
  <div class="home">
    <div id="carousel" ref="carousel" class="carousel slide" data-bs-ride="carousel">
      <div class="carousel-indicators">
          <button type="button" data-bs-target="#carousel" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
          <button type="button" data-bs-target="#carousel" data-bs-slide-to="1" aria-label="Slide 2"></button>
          <button type="button" data-bs-target="#carousel" data-bs-slide-to="2" aria-label="Slide 3"></button>
          <button type="button" data-bs-target="#carousel" data-bs-slide-to="3" aria-label="Slide 4"></button>
      </div>
      <div class="carousel-inner">
          <div class="carousel-item active">
              <img class="d-block w-100" src="/images/slide1.png" alt="First slide">
          </div>
          <div class="carousel-item">
              <img class="d-block w-100" src="/images/slide2.jpg" alt="Second slide">
          </div>
          <div class="carousel-item">
              <img class="d-block w-100" src="/images/slide4.jpg" alt="Third slide">
          </div>
          <div class="carousel-item">
              <img class="d-block w-100" src="/images/slide5.jpg" alt="Fourth slide">
          </div>
      </div>
      <button class="carousel-control-prev" type="button" data-bs-target="#carousel" data-bs-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
      </button>
      <button class="carousel-control-next" type="button" data-bs-target="#carousel" data-bs-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
      </button>
    </div>

    <br />
    <div class="container">
      <div class="d-flex justify-content-center align-items-center flex-wrap gap-3 gap-md-5">
          <router-link to="/brands/the-coffee-club"><img src="/images/tcc.png" class="brand-icon" alt="The Coffee Club" /></router-link>
          <router-link to="/brands/coffee-hit"><img src="/images/CoffeeHit_Logo.png" class="brand-icon" alt="Coffee Hit" /></router-link>
          <router-link to="/brands/veneziano"><img src="/images/VCR_LOGO.png" class="brand-icon" alt="Veneziano" /></router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { Carousel } from 'bootstrap'

export default {
  name: 'home',
  mounted () {
    this.carousel = new Carousel(this.$refs.carousel, { ride: 'carousel' })
  },
  beforeUnmount () {
    if (this.carousel) {
      this.carousel.dispose()
    }
  }
}
</script>

<style scoped>
/* Brand icons below the hero: large by default, smaller on phones */
.brand-icon {
  width: 150px;
  height: 150px;
  object-fit: contain;
}

@media (max-width: 575.98px) {
  .brand-icon {
    width: 90px;
    height: 90px;
  }
}

/* Cap the hero carousel to the content width on large screens so it
   isn't oversized on x-large/xx-large displays */
@media (min-width: 1200px) {
  #carousel {
    max-width: 1140px;
    margin-left: auto;
    margin-right: auto;
  }
}

@media (min-width: 1400px) {
  #carousel {
    max-width: 1320px;
  }
}
</style>
